import { styled, Box, Typography, Button } from "@mui/material"
import { Link } from "react-router-dom"

export const BoxUrl = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "0.25rem",
}))

export const BoxLink = styled(Link)({
  cursor: "pointer",
  color: "#757575",
  fontSize: "1.3rem",
  border: "none",
  background: "transparent",
  fontWeight: 500,
  textDecoration: "none",
  transition: "0.2s",
  "&:hover": {
    textDecoration: "underline",
  },
})

export const BoxPlace = styled(Typography)(({ theme }) => ({
  color: "#353535",
  fontSize: "1.3rem",
  fontWeight: 500,
  lineHeight: "1.5rem",
}))
